"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rulesReducer = void 0;
const lodash_1 = __importDefault(require("lodash"));
// Convert the Rules Data from the API to a flatter object that's easier to read and
// write to (less nested with edges/nodes)
const rulesDataToRulesObject = ({ rules }) => {
    return rules.edges.reduce((acc, { node: { id, enabled, name, variables } }) => {
        acc[name] = { id, enabled, variables };
        return acc;
    }, {});
};
function rulesReducer(rules, action) {
    switch (action.type) {
        case 'SET_RULES':
            return rulesDataToRulesObject(action.payload);
        case 'LAST_UPDATE_RECEIVED_ENABLED':
            return lodash_1.default.set(lodash_1.default.clone(rules), 'ShipmentLastUpdateReceived.enabled', action.payload);
        case 'LAST_UPDATE_RECEIVED_INTERVAL': {
            const updated = lodash_1.default.set(lodash_1.default.clone(rules), 'ShipmentLastUpdateReceived.variables', { lastScannedIntervalHours: parseInt(action.payload, 10) });
            return updated;
        }
        case 'RETURN_TO_SENDER_ENABLED':
            return lodash_1.default.set(lodash_1.default.clone(rules), 'ShipmentReturnedToSender.enabled', action.payload);
        case 'DELIVERY_ATTEMPTED_ENABLED':
            return lodash_1.default.set(lodash_1.default.clone(rules), 'ShipmentDeliveryAttempted.enabled', action.payload);
        default:
            return rules;
    }
}
exports.rulesReducer = rulesReducer;
